import type { FC, PropsWithChildren } from 'react'
import { Section } from '@matillion/component-library'
import classes from './PageContent.module.scss'

export const PageContent: FC<PropsWithChildren> = ({ children }) => {
  return <Section className={classes.Dashboard__Intro}>{children}</Section>
}
